<template>
  <div class="form-container">
    <div v-if="loading" class="loading-overlay">
      <b-spinner
        label="Loading..."
        variant="primary"
        class="spinner"
      ></b-spinner>
    </div>
    <h2>{{ title }}</h2>
    <div class="form-group-custom">
      <div class="upload-action">
        <span>Upload a Professional Profile Photo.</span>
        <label for="profile-photo" class="upload-btns">
          <span v-if="!form.image">Upload</span>
          <img v-else src="/static/img/Checkbox.svg" alt="Uploaded" />
          <input
            type="file"
            id="profile-photo"
            v-on:change="form.image"
            @change="handleFileUpload($event, 'image')"
            class="hidden-file-input"
          />
        </label>
      </div>

      <div class="upload-action">
        <span>Upload a copy of your Passport or Drivers License.</span>
        <label for="photoId" class="upload-btns">
          <span v-if="!form.photoId">Upload</span>
          <img v-else src="/static/img/Checkbox.svg" alt="Uploaded" />
          <input
            type="file"
            id="photoId"
            v-on:change="form.photoId"
            @change="handleFileUpload($event, 'photoId')"
            class="hidden-file-input"
          />
        </label>
      </div>

      <div class="upload-action">
        <span>Upload a copy of your Birth Certificate. </span>
        <label for="birth-certificate" class="upload-btns">
          <span v-if="!form.birthCert">Upload</span>
          <img v-else src="/static/img/Checkbox.svg" alt="Uploaded" />
          <input
            type="file"
            id="birth-certificate"
            v-on:change="form.birthCert"
            @change="handleFileUpload($event, 'birthCert')"
            class="hidden-file-input"
          />
        </label>
      </div>

      <div class="upload-action">
        <span
          >Upload a copy of your medical certificate
          {{ contains(1) ? "if applicable." : "" }}</span
        >
        <label for="medical-certificate" class="upload-btns">
          <span v-if="!form.medicalCert">Upload</span>
          <img v-else src="/static/img/Checkbox.svg" alt="Uploaded" />
          <input
            type="file"
            id="medical-certificate"
            v-on:change="form.medicalCert"
            @change="handleFileUpload($event, 'medicalCert')"
            class="hidden-file-input"
          />
        </label>
      </div>
    </div>

    <!--    <div class="gap" v-if="contains(1)">-->
    <!--      <div class="form-group-custom description">-->
    <!--        <h3>Meet with a local AME</h3>-->
    <!--        <p>-->
    <!--          In order to be medically approved to fly you must meet with a Aviation-->
    <!--          Medical Examiner (AME). Choose your preferred medical professional and-->
    <!--          a time below. Appointments typically last an hour.-->
    <!--        </p>-->
    <!--      </div>-->

    <!--      <div class="form-group-custom">-->
    <!--        <label for="localAME">Choose a local AME:</label>-->
    <!--        <HiloSelect-->
    <!--          :theme="'grey'"-->
    <!--          v-model="form.localAME"-->
    <!--          :options="[]"-->
    <!--          :placeholder="'Choose one...'"-->
    <!--          :customStyle="{-->
    <!--            height: '50px',-->
    <!--            width: '100%',-->
    <!--            padding: '10px',-->
    <!--          }"-->
    <!--        />-->
    <!--      </div>-->

    <!--      <div class="form-group-custom">-->
    <!--        <label>Schedule a time to meet with them:</label>-->
    <!--        <DateTimePicker @selected="selectedDate" />-->
    <!--      </div>-->
    <!--    </div>-->

    <div class="buttonContainer">
      <div class="nextButton" @click="handleNext">
        <b class="name">Next</b>
      </div>
      <div class="backButton" @click="$emit('onPrev')">
        <b class="name">Back</b>
      </div>
    </div>
  </div>
</template>
<script>
// import DateTimePicker from "../DateTimePicker.vue";
import SignUpAPIService from "@/servicehandlers/SignUpAPIService";
import get from "lodash/get";
const signUpAPIService = new SignUpAPIService();
//import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";

export default {
  components: {
    //HiloSelect,
  },
  props: {
    title: {
      type: String,
      required: false,
    },
    userId: {
      type: Number,
      required: true,
    },
    userTypeId: {},
  },
  data() {
    return {
      form: {
        image: "",
        photoId: "",
        birthCert: "",
        medicalCert: "",
      },
      loading: false,
    };
  },
  async mounted() {
    this.loading = true;
    try {
      await this.getSavedDocuments();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async getSavedDocuments() {
      try {
        const fetchedData = await signUpAPIService.getUserDocuments(
          this.userId,
        );
        if (fetchedData) {
          this.form = { ...this.form, ...fetchedData };
        }
      } catch (error) {}
    },
    contains(...ids) {
      return ids.includes(this.userTypeId);
    },
    handleFileUpload(event, fileType) {
      const file = event.target.files[0];
      if (file) {
        this.form[fileType] = file;
        this.$forceUpdate();
      }
    },
    async handleNext() {
      let isValid = true;
      const validations = [
        { field: "image", desc: "profile photo" },
        { field: "photoId", desc: "passport or drivers license" },
        { field: "birthCert", desc: "birth certificate" },
      ];

      for (const validation of validations) {
        const { field, desc } = validation;

        const fieldValue = get(this.form, field);

        if (
          fieldValue === undefined ||
          fieldValue === null ||
          fieldValue === "" ||
          (Array.isArray(fieldValue) && fieldValue.length === 0)
        ) {
          isValid = false;
          alert(`Please upload a ${desc}`);
          break;
        }
      }

      if (!isValid) return;
      try {
        this.loading = true;
        await signUpAPIService.createOrUpdateUserDocuments(
          this.userId,
          this.form,
        );
        this.$emit("onNext", { documents: this.form });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style>
.buttonContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
/* V2
.gap {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
*/
.buttonContainer div {
  align-self: stretch;
  border-radius: 10px;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
}

.buttonContainer div:hover {
  opacity: 0.8;
}

.nextButton {
  background-color: #3c78ff;
}

.backButton {
  background-color: #ccc;
}

.upload-action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-bottom: 30px;
}

.upload-action span {
  font-size: 15px !important;
}

.upload-btns {
  background-color: var(--vt-c-text-primary);
  border: none;
  border-radius: 5px;
  color: #fff;
  padding: 0.5rem 0.8rem !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  cursor: pointer;
}

.hidden-file-input {
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.description h3 {
  font-weight: bold;
}
</style>
